/*
 *  This script handles the form field value duplication.
 *
 *  It enables multiple bound fields to have the same value when one field value changes.
 */
import * as $ from 'jquery';

$('[data-duplicate-to]').on('change',
    function () {
        const $this = $(this);
        const $target = $($this.data('duplicate-to'));

        const isEmpty = !$target.val();
        if (isEmpty) {
            $target.val($this.val()).trigger('change').trigger('blur');
        }
    }
);

$('[data-copy-fields]').on('click',
    function () {
        const obj = $(this).data('copy-fields');
        const isEmpty = !$(`#${obj.Address}`).val() &&
            !$(`#${obj.City}`).val() &&
            !$(`#${obj.PostNumber}`).val();

        if (isEmpty) {
            $('[data-duplicate-to]').each((i, e) => {
                const target = $(e).data('duplicate-to');
                $(target).val($(e).val()).triggerHandler('change');
            });
        }
    }
);
